import axios, { AxiosResponse } from 'axios';

import { env } from '../../../config';
import { ComplaintReport, FailureReport } from '../types';

export function fetchReports(refPrestationPrise: string): Promise<
  AxiosResponse<{
    complaints: ComplaintReport[];
    failures: FailureReport[];
  }>
> {
  return axios.get(`${env.API_URL}/dataraccov2/reports`, {
    params: {
      refPrestationPrise
    }
  });
}
